The input parameter for the `jobCategorySuggestions` query.
